export default __webpack_public_path__ + "static/5-c7c7adcb6e2c148e73957d584f6d5986.jpg";